import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Monthlycorporatecabplanindelhi() {



  const cardData =
  {
    keyword: 'Monthly Corporate Cab Plans in Delhi',
    heading: 'Aaryan Travels: Monthly Corporate Cab Plans in Delhi',
    headingDescription: 'Aaryan Travels provides flexible Monthly Corporate Cab Plans in Delhi for companies, executives, and employees requiring consistent and professional transportation. Whether it’s daily office commute, client transfers, airport pickups from IGI Airport, or intercity travel to Noida, Gurgaon, or Faridabad, our fleet of sedans, SUVs, and premium vehicles is available on fixed monthly rental contracts. With trained chauffeurs, GPS-enabled vehicles, punctual reporting, and transparent billing, we ensure reliable corporate mobility across business hubs like Connaught Place, Okhla, Aerocity, and Cyber City. Aaryan Travels eliminates the hassle of daily bookings by offering customized monthly cab plans tailored to your corporate needs in Delhi.',

    top: 'Top Places to Visit in Delhi with Aaryan Travels',

 "topPlaces": [
  {
    "title": "Red Fort (Lal Qila)",
    "description": "Red Fort, built in 1648 by Emperor Shah Jahan, is a UNESCO World Heritage Site that served as the main residence of Mughal emperors. Its massive sandstone walls, royal chambers, and museum reflect Mughal grandeur. The evening sound-and-light show narrates the history of Delhi with dramatic visuals. Every Independence Day, the national flag is hoisted here. Red Fort is Delhi’s proud emblem of heritage and freedom."
  },
  {
    "title": "India Gate",
    "description": "India Gate is a 42-meter-high war memorial dedicated to soldiers who sacrificed their lives during World War I. Surrounded by lush lawns, it is a popular spot for evening walks and family outings. The Amar Jawan Jyoti flame burns eternally in their honor. Lit beautifully at night, it offers a majestic view. India Gate is Delhi’s national symbol of sacrifice and pride."
  },
  {
    "title": "Qutub Minar",
    "description": "Qutub Minar, standing at 73 meters, is the tallest brick minaret in the world. Built in the 12th century, it showcases Indo-Islamic architecture with intricate carvings and Quranic inscriptions. The surrounding complex includes historic mosques and the Iron Pillar that resists rust. Qutub Minar is Delhi’s towering testament to medieval craftsmanship."
  },
  {
    "title": "Lotus Temple",
    "description": "Lotus Temple is a Bahá’í House of Worship designed in the shape of a blooming lotus with 27 marble petals. Open to all faiths, it offers a tranquil environment for meditation and reflection. The surrounding pools and gardens enhance serenity. Silence is its only ritual. Lotus Temple is Delhi’s modern sanctuary of peace and unity."
  },
  {
    "title": "Humayun’s Tomb",
    "description": "Humayun’s Tomb, built in 1570, is a magnificent example of Mughal architecture and the inspiration behind the Taj Mahal. Surrounded by Persian-style gardens and water channels, it radiates symmetry and elegance. The red sandstone and white marble contrast beautifully. Humayun’s Tomb is Delhi’s masterpiece of love and legacy."
  },
  {
    "title": "Akshardham Temple",
    "description": "Akshardham Temple is a sprawling cultural and spiritual complex known for its breathtaking carvings and exhibitions. Built without steel, it features over 20,000 deities and sculptures. The evening musical fountain show is a visual delight. Boat rides narrate ancient Indian innovations. Akshardham is Delhi’s grand celebration of faith and craftsmanship."
  },
  {
    "title": "Jama Masjid",
    "description": "Jama Masjid, built in 1656 by Shah Jahan, is one of India’s largest mosques with a courtyard accommodating over 25,000 people. Its red sandstone domes and marble inlay work reflect Mughal elegance. Visitors climb the minaret for panoramic city views. The nearby lanes of Chandni Chowk offer delicious kebabs and biryani. Jama Masjid is Delhi’s spiritual and culinary landmark."
  },
  {
    "title": "Raj Ghat",
    "description": "Raj Ghat is a black marble memorial built at the cremation site of Mahatma Gandhi. Set amidst peaceful gardens, it carries the inscription 'Hey Ram'—his last words. Eternal flames symbolize his legacy of peace and non-violence. World leaders often visit to pay tribute. Raj Ghat is Delhi’s solemn homage to the Father of the Nation."
  },
  {
    "title": "Hauz Khas Village",
    "description": "Hauz Khas Village blends medieval ruins with trendy cafes, art galleries, and boutiques. The 14th-century Hauz Khas Fort overlooks a scenic lake, offering picturesque sunset views. At night, the area turns into a buzzing nightlife hub. Hauz Khas is Delhi’s fusion of history and modern lifestyle."
  },
  {
    "title": "Chandni Chowk & Paranthe Wali Gali",
    "description": "Chandni Chowk is one of Delhi’s oldest and busiest markets known for spices, jewelry, and fabrics. Paranthe Wali Gali is famous for its stuffed parathas served with pickles and chutneys. Rickshaws, temples, and street food create a bustling yet charming atmosphere. Chandni Chowk is Delhi’s flavorful maze of culture and chaos."
  }
],


"services": [
  {
    "name": "Monthly Corporate Cab Plans in Delhi",
    "description": "Monthly Corporate Cab Plans in Delhi offer flexible and cost-effective transportation solutions for businesses. Designed for daily commutes, meetings, and executive travel, our plans include premium vehicles, trained chauffeurs, and detailed monthly billing for seamless corporate mobility."
  },
  {
    "name": "Delhi Corporate Monthly Cab",
    "description": "Delhi Corporate Monthly Cab service provides dedicated cabs for businesses on a monthly basis. With reliable drivers, well-maintained vehicles, and priority service, it ensures timely employee pickups and drop-offs across the city, customized to your company’s needs."
  },
  {
    "name": "Business Cab Subscription Delhi",
    "description": "Business Cab Subscription Delhi enables companies to subscribe to premium cab services for regular use. Ideal for daily employee travel or executive transportation, our subscription offers convenience, consistent quality, and simplified billing cycles."
  },
  {
    "name": "Chauffeur Corporate Cab Delhi Monthly",
    "description": "Chauffeur Corporate Cab Delhi Monthly provides high-end vehicles with professional chauffeurs for monthly corporate use. Perfect for executives and clients, the service ensures punctuality, privacy, and luxury, making every business trip comfortable and efficient."
  },
  {
    "name": "Office Transport Delhi Monthly",
    "description": "Office Transport Delhi Monthly is tailored for organizations needing regular staff transport. Our service includes fixed routes, trained drivers, and safe vehicles to ensure hassle-free daily commutes for employees across various office locations in Delhi."
  },
  {
    "name": "Staff Cab Hire Delhi Monthly",
    "description": "Staff Cab Hire Delhi Monthly offers dependable monthly cab services for employee transportation. With GPS-enabled vehicles, route optimization, and punctual scheduling, we help businesses ensure smooth and safe staff commutes every day."
  },
  {
    "name": "Corporate Taxi Delhi Monthly",
    "description": "Corporate Taxi Delhi Monthly provides affordable and consistent taxi services for businesses requiring frequent travel. With professional chauffeurs and flexible plans, this service is ideal for office staff, field teams, and executive movements across the city."
  },
  {
    "name": "Corporate Vehicle Rental Delhi",
    "description": "Corporate Vehicle Rental Delhi offers a wide range of sedans, SUVs, and luxury cars for long-term rental. Suitable for daily office use, business events, and executive travel, we ensure high standards of maintenance and service excellence."
  },
  {
    "name": "Executive Corporate Cab Delhi",
    "description": "Executive Corporate Cab Delhi delivers top-tier travel solutions for senior management and VIP guests. Featuring high-end vehicles and experienced chauffeurs, our service guarantees a professional and luxurious experience every time."
  },
  {
    "name": "Affordable Corporate Cab Delhi",
    "description": "Affordable Corporate Cab Delhi combines quality and value, offering budget-friendly monthly plans for businesses. With clean vehicles, trained drivers, and on-time service, we help companies manage transport costs without sacrificing reliability."
  },
  {
    "name": "Corporate Car Leasing Delhi",
    "description": "Corporate Car Leasing Delhi provides long-term car lease options for companies in need of consistent transportation. Our leasing plans include maintenance, insurance, and driver support, ideal for businesses looking for cost-effective and flexible vehicle solutions."
  },
  {
    "name": "Monthly Business Cab Delhi",
    "description": "Monthly Business Cab Delhi caters to professionals and businesses requiring regular travel within Delhi. Our monthly service ensures availability, comfort, and accountability with dedicated cabs and detailed trip records for business use."
  },
  {
    "name": "Online Corporate Plan Delhi",
    "description": "Online Corporate Plan Delhi makes it easy to manage and book monthly cab services through our digital platform. With features like ride tracking, billing reports, and centralized scheduling, this service brings convenience and transparency to corporate transport management."
  },
  {
    "name": "Long Term Corporate Cab Delhi",
    "description": "Long Term Corporate Cab Delhi provides extended-use cab services for companies requiring vehicles for several months or more. Ideal for consistent employee travel or special business projects, our service includes maintenance, replacements, and 24/7 support."
  },
  {
    "name": "Corporate Transport Solutions Delhi",
    "description": "Corporate Transport Solutions Delhi offers end-to-end transportation services for businesses of all sizes. From employee shuttles to executive cars, we deliver scalable, customizable, and efficient travel options to meet corporate mobility requirements."
  }
],
"tableData": [
  ["Monthly Corporate Cab Plans in Delhi", "Delhi Corporate Monthly Cab"],
  ["Business Cab Subscription Delhi", "Chauffeur Corporate Cab Delhi Monthly"],
  ["Office Transport Delhi Monthly", "Staff Cab Hire Delhi Monthly"],
  ["Corporate Taxi Delhi Monthly", "Corporate Vehicle Rental Delhi"],
  ["Executive Corporate Cab Delhi", "Affordable Corporate Cab Delhi"],
  ["Corporate Car Leasing Delhi", "Monthly Business Cab Delhi"],
  ["Online Corporate Plan Delhi", "Long Term Corporate Cab Delhi"],
  ["Corporate Transport Solutions Delhi", "—"]
],

"whychoose": [
  {
    "WhyChooseheading": "Monthly Corporate Cab Plans in Delhi",
    "WhyChoosedescription": "Aaryan Travels offers flexible monthly corporate cab plans in Delhi tailored for regular business commuters."
  },
  {
    "WhyChooseheading": "Reliable and Punctual Service",
    "WhyChoosedescription": "Our drivers ensure timely pickups and drop-offs, making your daily commute hassle-free and efficient."
  },
  {
    "WhyChooseheading": "Well-Maintained and Comfortable Vehicles",
    "WhyChoosedescription": "Travel in clean, sanitized, and air-conditioned cars designed for comfort during your daily rides."
  },
  {
    "WhyChooseheading": "Experienced Drivers Familiar with Delhi Routes",
    "WhyChoosedescription": "Our professional drivers know Delhi’s traffic patterns and routes to provide smooth and timely rides."
  },
  {
    "WhyChooseheading": "Transparent Monthly Pricing with No Hidden Charges",
    "WhyChoosedescription": "Enjoy fixed monthly rates that cover all costs including fuel, tolls, and driver allowances."
  },
  {
    "WhyChooseheading": "24/7 Customer Support for Corporate Clients",
    "WhyChoosedescription": "Our dedicated support team is available round the clock to assist with bookings and queries."
  },
  {
    "WhyChooseheading": "Customizable Plans to Fit Your Business Needs",
    "WhyChoosedescription": "Choose from various plans and vehicle types that best suit your corporate travel requirements."
  },
  {
    "WhyChooseheading": "Priority Service and Dedicated Fleet",
    "WhyChoosedescription": "Benefit from priority booking and a dedicated fleet for uninterrupted corporate travel."
  }
]




































  }

const faqData = [
  {
    question: 'Does Aaryan Travels offer monthly corporate cab plans in Delhi?',
    answer: 'Yes, Aaryan Travels provides flexible and cost-effective monthly corporate cab plans tailored for businesses in Delhi.',
  },
  {
    question: 'How can I subscribe to monthly corporate cab plans in Delhi with Aaryan Travels?',
    answer: 'You can subscribe through our website, mobile app, or by contacting our dedicated corporate support team available 24x7.',
  },
  {
    question: 'What types of vehicles are available under the monthly corporate cab plans in Delhi?',
    answer: 'Aaryan Travels offers a variety of vehicles including sedans, SUVs, and premium cars to suit your corporate travel needs.',
  },
  {
    question: 'Are drivers experienced with Delhi city routes for monthly corporate plans?',
    answer: 'Absolutely. Our professional drivers are licensed and familiar with Delhi’s traffic and routes to ensure timely and comfortable rides.',
  },
  {
    question: 'Can I customize pickup and drop-off locations for monthly corporate cab plans in Delhi?',
    answer: 'Yes, you can specify daily pickup and drop-off points anywhere within Delhi and nearby business areas.',
  },
  {
    question: 'Are monthly corporate cab plans available 24x7 in Delhi?',
    answer: 'Yes, Aaryan Travels offers 24x7 services for monthly corporate cab plans to accommodate your business schedule.',
  },
  {
    question: 'Are safety and hygiene protocols followed for monthly corporate cab services?',
    answer: 'All vehicles are sanitized regularly, and drivers adhere to strict safety and hygiene protocols for your protection.',
  },
  {
    question: 'What payment options are accepted for monthly corporate cab plans in Delhi?',
    answer: 'We accept cash, corporate accounts, digital wallets, UPI, and card payments for your convenience.',
  },
  {
    question: 'Is customer support available during monthly corporate cab rides in Delhi?',
    answer: 'Yes, our 24x7 customer support team is available to assist you throughout your subscription period.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Anil Verma',
    feedback: 'Aaryan Travels’ monthly corporate cab plan in Delhi has streamlined our employee commute with great service and reliability.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Neha Sharma',
    feedback: 'Efficient and hassle-free monthly corporate cab service by Aaryan Travels in Delhi. Highly recommended for businesses!',
    rating: 5,
  },
];





















































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Corporate Cab Services in Pune", link: "corporate-cab-services-in-pune" },
    { place: "/images/keyword/2.jpg", text: "Best Cab Services in Pune", link: "best-cab-services-in-pune" },
    { place: "/images/keyword/3.jpg", text: "Best Cab Services in Kochi", link: "best-cab-services-in-kochi" },
    { place: "/images/keyword/4.jpg", text: "Cab booking from Mumbai to Pune", link: "cab-booking-from-mumbai-to-pune" },
    { place: "/images/keyword/5.jpg", text: "Cab from Pune to Mahabaleshwar", link: "cab-from-pune-to-mahabaleshwar" },
    { place: "/images/keyword/6.jpg", text: "Monthly Cab hire contract in Hyderabad", link: "monthly-cab-hire-contract-in-hyderabad" },
    { place: "/images/keyword/7.jpg", text: "Taxi Services from Pune to Shirdi", link: "taxi-services-from-pune-to-shirdi" },
    { place: "/images/keyword/8.jpg", text: "Pune to Shirdi Cab", link: "pune-to-shirdi-cab" },
    { place: "/images/keyword/9.jpg", text: "Mumbai to Pune Corporate Cab", link: "mumbai-to-pune-corporate-cab" },
    { place: "/images/keyword/10.jpg", text: "Outstation Cab Services from Pune", link: "outstation-cab-services-from-pune" },
    { place: "/images/keyword/11.jpg", text: "Innova Crysta rental in Pune", link: "innova-crysta-rental-in-pune" },
    { place: "/images/keyword/12.jpg", text: "Corporate Cab hire in Pune", link: "corporate-cab-hire-in-pune" },
    { place: "/images/keyword/13.jpg", text: "Pune to Shirdi Corporate Cab booking", link: "pune-to-shirdi-corporate-cab-booking" },
    { place: "/images/keyword/14.jpg", text: "Pune to Mumbai Corporate Cab Services", link: "pune-to-mumbai-corporate-cab-services" },
    { place: "/images/keyword/15.jpg", text: "Monthly Corporate Cab rental in Chennai", link: "monthly-corporate-cab-rental-in-chennai" },
    { place: "/images/keyword/16.jpg", text: "Wedding Corporate Cab bookings in Pune", link: "wedding-cab-bookings-in-pune" },
    { place: "/images/keyword/17.jpg", text: "Corporate Cab Services in Kharadi, Pune", link: "corporate-cab-services-in-kharadi-pune" },
    { place: "/images/keyword/18.jpg", text: "Corporate Cab Services in Ranchi", link: "corporate-cab-services-in-ranchi" },
    { place: "/images/keyword/19.jpg", text: "Corporate Cab Services in Vadodara", link: "corporate-cab-services-in-vadodara" },
    { place: "/images/keyword/20.jpg", text: "Corporate Cab booking in Ranchi", link: "corporate-cab-booking-in-ranchi" },
    { place: "/images/keyword/21.jpg", text: "Corporate Cab booking in Vadodara", link: "corporate-cab-booking-in-vadodara" },
    { place: "/images/keyword/22.jpg", text: "Taxi booking in Ranchi", link: "taxi-booking-in-ranchi" },
    { place: "/images/keyword/23.jpg", text: "Corporate Cab Services in India", link: "corporate-cab-services-in-india" },
    { place: "/images/keyword/24.jpg", text: "Taxi Services in Vadodara, Gujarat", link: "taxi-services-in-vadodara-gujarat" },
    { place: "/images/keyword/25.jpg", text: "Taxi booking in Vadodara", link: "taxi-booking-in-vadodara" }
  ];





const monthlyCorporateCabDelhiSchema = {
  "@context": "https://schema.org",
  "@type": "Service",
  "name": "Monthly Corporate Cab Plans in Delhi",
  "description": "Aaryan Travels offers affordable monthly corporate cab plans in Delhi, including chauffeur-driven business cabs, office transport, staff cab hire, and long-term corporate vehicle rentals.",
  "provider": {
    "@type": "Organization",
    "name": "Aaryan Travels",
    "url": "https://aaryantravels.com"
  },
  "areaServed": {
    "@type": "City",
    "name": "Delhi"
  },
  "serviceType": "Monthly Corporate Cab Rental",
  "keywords": "Monthly Corporate Cab Plans in Delhi, Delhi Corporate Monthly Cab, Business Cab Subscription Delhi, Chauffeur Corporate Cab Delhi Monthly, Office Transport Delhi Monthly, Staff Cab Hire Delhi Monthly, Corporate Taxi Delhi Monthly, Corporate Vehicle Rental Delhi, Executive Corporate Cab Delhi, Affordable Corporate Cab Delhi, Corporate Car Leasing Delhi, Monthly Business Cab Delhi, Online Corporate Plan Delhi, Long Term Corporate Cab Delhi, Corporate Transport Solutions Delhi"
};









  return (
    <div>
<Helmet>
  <title>Monthly Corporate Cab Plans in Delhi | Affordable Business Cab Rentals | Aaryan Travels</title>
  <meta
    name="description"
    content="Book monthly corporate cab plans in Delhi with Aaryan Travels. Chauffeur-driven business cabs, staff transport, and long-term corporate vehicle rentals at affordable rates."
  />
  <meta
    name="keywords"
    content="Monthly Corporate Cab Plans in Delhi, Delhi Corporate Monthly Cab, Business Cab Subscription Delhi, Chauffeur Corporate Cab Delhi Monthly, Office Transport Delhi Monthly, Staff Cab Hire Delhi Monthly, Corporate Taxi Delhi Monthly, Corporate Vehicle Rental Delhi, Executive Corporate Cab Delhi, Affordable Corporate Cab Delhi, Corporate Car Leasing Delhi, Monthly Business Cab Delhi, Online Corporate Plan Delhi, Long Term Corporate Cab Delhi, Corporate Transport Solutions Delhi"
  />
  <script type="application/ld+json">
    {JSON.stringify(monthlyCorporateCabDelhiSchema)}
  </script>
</Helmet>



      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box">
                <h1 className="text-anime-style-3" data-cursor="-opaque">
                   {cardData.keyword}
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>










      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/54.jpg' alt='img' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Aaryan Travels</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Aaryan Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919730707888" className="pc-call">+91 9730707888</a>
                      <a href="tel:+919833377051" className="pc-call">+91 9833377051</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919730707888"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+919730707888" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:bookings@aaryantravels.com" className="pc-email">
                      bookings@aaryantravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Aryan Travels Pune Head Office</strong><br />
                      Flat 304, Plot-82, Prathmesh Krupa, Purnanagar/Chikhali Pune- 411019.
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Monthlycorporatecabplanindelhi;